require('../step.scss');
require('./cardMobileRechargeStep2.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');

//@helpers
const { FormattedText } = require('core/i18n').i18n;
const {CARD_MOBILE_RECHARGE} = require('constants/operationTypes');
const { nonNumericFilter } = require('utilities/stringHelper');

//@components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;

class CardMobileRechargeStep2 extends React.Component {
    
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {immCards, cardId, immCardMobileRecharge} = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const operationParams = {
            pan: nonNumericFilter(immCard.get('number')),
            ammount: immCardMobileRecharge.getIn(['steps', 0, 'selectedAmount', 'amount']),
            currency: immCardMobileRecharge.getIn(['steps', 0, 'selectedAmount', 'currency'])
        };

        return (
            <div className="card-mobile-recharge-step">
                <header className="card-mobile-recharge-step__header">
                    <h5 className="card-mobile-recharge-step__title">
                        <FormattedText value="cardMobileRecharge-secondStepTitle" />
                    </h5>
                </header>
                <article className="card-mobile-recharge-step__content">
                    <section>
                        <FormattedText value="cardMobileRecharge-secondStepInformativeText" className="card-mobile-recharge-step-two__informative-text" />
                    </section>
                    <section className="card-mobile-recharge-step-two__signature-pattern">
                        <SignaturePattern
                            operationType={CARD_MOBILE_RECHARGE}
                            operationParams={operationParams}
                        />
                    </section>
                </article>
            </div>
        );
    }
}

CardMobileRechargeStep2.propTypes = {
    immCardMobileRecharge: PropTypes.object,
    immCards: PropTypes.object,
    cardId: PropTypes.string
};

module.exports = CardMobileRechargeStep2;